<template>
  <div class="hello">
    <h1 class="mt-4">Arwèn Wind</h1>
    <h4>Hello world 👋</h4>
    <img src="../assets/arwen.jpg" alt="Arwèn Wind" class="img-thumbnail rounded arwen">
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  img.arwen {
    max-height: 80vh;
    max-width: 90vw;
  }
</style>
